import { render } from "./Search.vue?vue&type=template&id=7264dbf3&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"

import "@/Common/Styles/profilePanels.scss?vue&type=style&index=0&id=7264dbf3&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7264dbf3"]])

export default __exports__